import { useEffect,useRef } from "react";
import { useSelector } from "react-redux";

export const useHistoryDataSelector = () => {
    const retailerMapingHistoryData =
      useSelector((state) => state?.retailerMapping?.retailerMappingHistory?.data) || {};
    const retailerMapingHistoryDataLoading =
      useSelector(
        (state) =>state?.retailerMapping?.retailerMappingHistory?.isLoading
      ) || false;
    const retailerMapingHistoryDataError =
      useSelector((state) => state?.retailerMapping?.retailerMappingHistory?.error) ||
      null;
    const prevLoadingRef = useRef(false);
    const prevLoading = prevLoadingRef.current;
    useEffect(() => {
      prevLoadingRef.current = retailerMapingHistoryDataLoading;
    });
  
    return {
        historyData: retailerMapingHistoryData,
        historyDataLoading: retailerMapingHistoryDataLoading,
        historyDataError: retailerMapingHistoryDataError,
        historyDataPrevLoading: prevLoading,
    };
  };
  